<template>
  <div id="" class="content" style="width: 100%">
    <p class="fTitle"><label style="margin-left: 15px">报名信息</label></p>
    <div class="conten-box">
      <div style="margin-bottom: 15px">
        <el-select
          v-model="matchId"
          @change="getMsgList"
          placeholder="请选择赛事"
          style="width: 500px"
        >
          <!--   <el-option label="2019上半年等级测试" value="1"></el-option>-->
          <el-option
            v-for="item in listMatches"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </div>
      <div class="status-box">
        <ul class="">
          <li
            :class="activeIndex == index ? 'active' : ''"
            @click="changeStatus(index)"
            v-for="(item, index) in statusList"
            :key="item.id"
            class="pay-status"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>

      <div :key="index" v-for="(firstItem, index) in firstClass">
        <template>
          <div class="table-box">
            <div class="search-box">
              <p>{{ firstItem.typesData }}</p>
            </div>
            <div class="table-content">
              <el-table
                :data="firstItem.tableData"
                size="mini"
                @selection-change="changeSelect($event, index)"
                border
                style="width: 100%"
              >
                <el-table-column
                  type="selection"
                  :selectable="selectable"
                  width="50"
                >
                </el-table-column>

                <el-table-column label="编号" type="index" width="50">
                </el-table-column>

                <el-table-column prop="userName" label="姓名" width="80">
                </el-table-column>

                <el-table-column
                  prop="gender"
                  label="性别"
                  :formatter="formatRole"
                  width="60"
                >
                </el-table-column>

                <el-table-column prop="cost" label="证件号" width="160">
                </el-table-column>

                <el-table-column prop="userIdcode" width="50" label="费用">
                </el-table-column>

                <el-table-column prop="orgName" width="100" label="组织名称">
                </el-table-column>

                <el-table-column prop="achievement" width="170" label="成绩">
                </el-table-column>

                <el-table-column width="100" label="支付状态">
                  <template slot-scope="scope">
                    <span
                      :style="{
                        color: scope.row.paystatus == 'N' ? '#ff6000' : '',
                      }"
                      >{{ scope.row.paystatus | formatPay }}</span
                    >
                  </template>
                </el-table-column>

                <el-table-column prop="birthday" width="95" label="出生日期">
                </el-table-column>

                <el-table-column prop="coachName" width="" label="教练姓名">
                </el-table-column>

                <el-table-column prop="coachTel" width="110" label="教练手机号">
                </el-table-column>

                <!-- <el-table-column label="操作" width="200" align="center" fixed="right">
                  <template slot-scope="scope">
                    <el-button type="danger" size="small" style="padding: 7px 15px;border: none;"
                      :disabled="scope.row.paystatus != 'N'" @click="paySingle(scope.row.id, scope.row.arrangementId)"
                      :style="{ background: scope.row.paystatus == 'N' ? '#ff6000' : '#d1d1d1' }">
                      立即支付
                    </el-button>
                    <el-button type="danger" style="padding: 7px 15px;border: none;"
                      :disabled="scope.row.paystatus != 'N'" @click="deletes(scope.row)"
                      :style="{ background: scope.row.paystatus == 'N' ? '#ff6000' : '#d1d1d1' }" size="small">
                      删除</el-button>
                  </template>
                </el-table-column> -->
              </el-table>
            </div>
          </div>
        </template>
      </div>
      <div
        v-if="firstClass.length === 0"
        style="margin-top: 20px; width: 100%; text-align: center"
      >
        暂无数据
      </div>
      <div style="margin-top: 20px">
        <button
          @click="payAll()"
          :class="{ 'disarrow-pay-all': !haveList }"
          class="pay-all"
        >
          付款
        </button>
        <button
          @click="deletes()"
          :class="{ 'disarrow-pay-all': !haveList }"
          class="pay-all"
        >
          批量删除
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { get, post } from "@/api/fetch.js";
import url from "@/api/serviceAPI.config.js";

export default {
  data() {
    return {
      identity: "2", //（2=组织，3=个人）
      events: "1",
      orgId: "", //组织
      haveList: false,
      personId: 24413, //个人
      matchId: "",
      submitList: [],
      listLoading: "",
      payStatus: "A",
      statusList: [
        {
          name: "全部报名",
          payStatus: "A",
        },
        // {
        //   name: "已报名",
        //   payStatus: "Y",
        // },
        // {
        //   name: "未报名",
        //   payStatus: "N",
        // },
      ],
      activeIndex: 0,
      firstClass: [],
      listMatches: [],
      arrangementIdList: [],
    };
  },
  methods: {
    changeStatus(index) {
      this.haveList = false;
      this.activeIndex = index;
      this.payStatus = this.statusList[index].payStatus;
      this.firstClass = [];
      this.getMsgList();
    },
    dealIce(icRegis) {
      let icRegisDataZ;
      icRegis.forEach((item, index) => {
        icRegisDataZ = { ...icRegisDataZ, ...this.secondDeal(item) };
      });
      return icRegisDataZ;
    },
    secondDeal(data) {
      return data.reduce((prev, cur, index) => {
        let { arrangement, registrationinfo } = cur;
        registrationinfo.forEach((item, itemIndex) => {
          item.groupIndex = index;
          item.readIndex = index * 2 + itemIndex;
        });
        let { attribute1, attribute2, attribute3 } = arrangement;
        let attribute = attribute1 + attribute2 + attribute3;
        /*(prev[attribute]=prev[attribute]||[]).push(registrationinfo)*/
        prev[attribute] = [...(prev[attribute] || []), ...registrationinfo];
        return prev;
      }, {});
    },
    getMsgList() {
      this.firstClass = [];
      this.orgId = JSON.parse(sessionStorage.getItem("userId"));
      this.identity = JSON.parse(sessionStorage.getItem("type"));
      post(url.getAllPayList, {
        matchId: this.matchId,
        orgId: this.orgId,
        personId: this.orgId,
        payStatus: this.payStatus,
        type: this.identity,
      }).then((res) => {
        let { data, icRegis } = res;
        let icRegisData = this.dealIce(icRegis); // 冰舞数据
        for (let i in icRegisData) {
          let iceTeam = icRegisData[i];
          let obj = {
            typesData: "", //类别
            time: "",
            typetotalPrice: 0,
            typeSubmitList: [],
            tableData: [],
          };
          obj.typesData = i;
          for (let i = 0; i < iceTeam.length; i += 2) {
            let iceTeamItemP = iceTeam[i + 1];

            console.log(iceTeam[i]);

            let {
              personName,
              arrangementId,
              id,
              cost,
              gender,
              credentialsNo,
              payStauts,
              createTime,
              groupIndex,
              readIndex,
              orgName,
              achievement,
              birthday,
              coachName,
              coachTel,
            } = iceTeam[i];
            let personNameP = iceTeamItemP.personName,
              idP = iceTeamItemP.id,
              costP = iceTeamItemP.cost,
              genderP = iceTeamItemP.gender,
              credentialsNoP = iceTeamItemP.credentialsNo,
              payStautsP = iceTeamItemP.payStauts,
              createTimeP = iceTeamItemP.createTime,
              groupIndexP = iceTeamItemP.groupIndex,
              readIndexP = iceTeamItemP.readIndex,
              orgNameP = iceTeamItemP.orgName,
              birthdayP = iceTeamItemP.birthday,
              coachNameP = iceTeamItemP.coachName,
              coachTelP = iceTeamItemP.coachTel;
            obj.tableData.push({
              cost: `${credentialsNo}/${credentialsNoP}`, //身份证
              userName: `${personName}/${personNameP}`,
              userIdcode: cost + costP || 0,
              paystatus: payStauts,
              achievement,
              createTime,
              orgName,
              gender: `${gender}/${genderP}`,
              groupIndex,
              arrangementId,
              id: `${id},${idP}`,
              birthday: `${birthday ? birthday.split(" ")[0] : birthday}/${
                birthdayP ? birthdayP.split(" ")[0] : birthdayP
              }`,
              coachName: `${coachName}/${coachNameP}`,
              coachTel: `${coachTel}/${coachTelP}`,
            });
          }
          this.firstClass.push(obj);
        }
        for (let item of data) {
          let arrangement = item.arrangement;
          let registrationinfo = item.registrationinfo;

          let obj = {
            typesData: "", //类别
            typetotalPrice: 0,
            typeSubmitList: [],
            tableData: [],
          };
          for (let i in arrangement) {
            let classname = item.arrangement[i];
            if (classname && i.indexOf("attribute") != -1)
              obj.typesData += classname;
          }
          for (let i in registrationinfo) {
            let {
              personName,
              id,
              achievement,
              orgName,
              cost,
              gender,
              credentialsNo,
              payStauts,
              arrangementId,
              birthday,
              coachName,
              coachTel,
            } = registrationinfo[i];
            obj.tableData.push({
              cost: credentialsNo, //身份证
              userName: personName,
              achievement: achievement,
              orgName: orgName,
              gender: gender,
              userIdcode: cost || 0,
              paystatus: payStauts,
              id: id,
              arrangementId,
              birthday: birthday ? birthday.split(" ")[0] : birthday,
              coachName,
              coachTel,
            });
          }
          this.firstClass.push(obj);
        }
        console.log("@@", this.firstClass);
      });
    },
    formatRole: function (row, column) {
      if (row.gender.indexOf("/") != -1) {
        let genderArr = row.gender.split("/");
        let genderA =
          genderArr[0] == "1" ? "男" : genderArr[0] == "2" ? "女" : "性别不详";
        let genderB =
          genderArr[1] == "1" ? "男" : genderArr[1] == "2" ? "女" : "性别不详";
        return genderA + "/" + genderB;
      } else {
        return row.gender == "1" ? "男" : row.gender == "2" ? "女" : "性别不详";
      }
    },
    selectable(row, column) {
      if (row.paystatus == "N") {
        //你需要判断的条件
        return 1; //可勾选
      } else {
        return 0; //不可勾选
      }
    },
    paySingle(id, arrangementId) {
      post(url.saveMoney1, {
        registrationInfoId: id || this.submitList,
        matchId: this.matchId,
        id: this.orgId,
        createType: this.identity,
        arrangementId,
      }).then((res) => {
        if (res.status !== 500) {
          this.$router.push({
            path: "/index/choosePayWay",
            query: { orderNo: res.orderNo, money: res.cost },
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    payAll() {
      post(url.saveMoney1, {
        registrationInfoId: this.submitList,
        matchId: this.matchId,
        id: this.orgId,
        createType: this.identity,
        arrangementId: this.arrangementIdList,
      }).then((res) => {
        if (res.status !== 500) {
          this.$router.push({
            path: "/index/choosePayWay",
            query: { orderNo: res.orderNo, money: res.cost },
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    getGameLists() {
      return new Promise((resolve) => {
        post(url.listMatche).then((res) => {
          this.listMatches = res.data;
          this.matchId = this.listMatches[this.listMatches.length - 1].id;
          resolve();
        });
      });
    },
    deletes(row) {
      console.log("1", row);
      let id;
      if (row) {
        if (String.prototype.indexOf.call(row.id, ",") != -1) {
          id = [row.id.split(",")[0], row.id.split(",")[1]];
        } else {
          id = row.id;
        }
      }
      let ids = id || this.submitList;
      console.log(ids);
      this.$confirm("确认删除吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          post(url.deletePlay, {
            registrationInfoId: ids,
            matchId: this.matchId,
          }).then((res) => {
            this.listLoading = false;
            if (res.status == 200) {
              this.$notify({
                title: "删除成功",
                message: "删除成功",
                type: "success",
                duration: 2000,
                onClose: () => {
                  this.getMsgList();
                },
              });
            } else {
              this.$notify({
                title: "删除失败",
                message: "删除失败",
                type: "error",
                duration: 2000,
              });
            }
          });
        })
        .catch(() => {});
    },
    changeSelect(val, index) {
      let typetotalPrice = 0;
      let totalPrice = 0;
      let typeSubmitList = [];
      let submitList = [];
      let arrangementIdList = [];
      for (var item of val) {
        arrangementIdList.push(item.arrangementId);
        typetotalPrice += parseInt(item.id);
        if (String(item.id).indexOf(",") != -1) {
          typeSubmitList.push(item.id.split(",")[0]);
          typeSubmitList.push(item.id.split(",")[1]);
        } else {
          typeSubmitList.push(item.id);
        }
      }
      this.firstClass[index].typetotalPrice = typetotalPrice; //单个table总价
      this.firstClass[index].typeSubmitList = typeSubmitList; //单个table勾选数据
      this.firstClass[index].arrangementIdList = arrangementIdList;
      arrangementIdList = [];
      for (var items of this.firstClass) {
        totalPrice += items.typetotalPrice;
        submitList = submitList.concat(items.typeSubmitList);
        arrangementIdList = arrangementIdList.concat(items.arrangementIdList);
      }

      this.submitList = submitList;
      this.arrangementIdList = arrangementIdList.filter((item) => !!item);
      if (this.submitList.length) this.haveList = true;
      else this.haveList = false;
      post(url.countMoney, { registrationInfoId: this.submitList }).then(
        (res) => {
          this.totalPrice = res;
        }
      );
    },
  },
  filters: {
    formatPay: function (paystatus) {
      // return paystatus == "N"
      //   ? "未支付"
      //   : paystatus == "Y"
      //   ? "已支付"
      //   : paystatus == "P"
      //   ? "支付中"
      //   : "订单异常";
      return paystatus == "N"
        ? "未支付"
        : paystatus == "Y"
        ? "已支付"
        : paystatus == "P"
        ? "未支付"
        : "";
    },
  },
  created() {
    this.getGameLists().then(() => {
      this.getMsgList();
    });
  },
};
</script>

<style type="text/scss" lang="scss" scoped>
.pay-all {
  padding: 7px 15px;
  border: none;
  background: #5a5cbb;
  color: #fff;
  cursor: pointer;
}

.disarrow-pay-all {
  display: none;
  background: rgb(255, 255, 255);
}

.fTitle {
  height: 32px;
  line-height: 32px;
  width: 100%;
  background: #fefefe;
  border: 1px solid #ddd;
  margin-bottom: 20px;
  color: #a7a7a7;
}

.status-box {
  height: 32px;
  border-bottom: 2px solid #5a5cbb;
}

.pay-status {
  float: left;
  width: 110px;
  height: 31px;
  text-align: center;
  line-height: 31px;
  border: 1px solid #ddd;
  background: #f9f9f9;
  cursor: pointer;
  margin-right: 15px;
  border-bottom: none;
  color: #666;
}

.search-box {
  height: 50px;
  background: #eaf8ff;
  line-height: 50px;
  border: 1px solid #e8e8e8;
  padding-left: 25px;
  border-bottom: none;
}

.table-content {
  padding: 20px;
  border: 1px solid #e8e8e8;
}

.active {
  color: #fff;
  background: #5a5cbb;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/orderList.vue